// #region Imports
import { defineComponent, nextTick } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-modal-slide',
    // #endregion
    // #region Properties
    props: {
        id: {
            type: String,
            required: true
        },
        position: {
            type: String,
            default: 'right'
        },
        size: {
            type: String,
            default: 'default'
        },
        closeOnKeyEsc: {
            type: Boolean,
            required: false,
            default: true
        },
        closeOnOutsideClick: {
            type: Boolean,
            required: false,
            default: true
        },
        closable: {
            type: Boolean,
            required: false,
            default: true
        },
        windowCallback: {
            type: Function,
            required: false,
            default: null
        },
    },
    data: () => ({
        visible: false,
        visible2: false
    }),
    computed: {
        modalClasses() {
            return {
                [`position-${this.position}`]: this.position,
                [`size-${this.size}`]: this.size,
            };
        },
        identifierClass() {
            return `g-modal--${this.id}`;
        },
    },
    // #endregion
    // #region Constructor
    created() {
        this.show();
    },
    mounted() {
        this.setFocusToModal();
    },
    // #endregion
    // #region Core
    methods: {
        setFocusToModal() {
            let tDialog = this.$refs.dialog;
            this.$nextTick(() => {
                tDialog.focus();
            });
        },
        show() {
            this.visible = true;
            nextTick(() => {
                this.visible2 = true;
            });
        },
        close(state) {
            // #region Self
            this.visible2 = false;
            // #endregion
            // #region Timer
            setTimeout(() => {
                //Close
                host.notification.closeModal(this.id);
                //Callback
                if (this.windowCallback) {
                    if (utils.isObject(state)) {
                        this.windowCallback(state);
                    }
                    else {
                        this.windowCallback({
                            state: state ?? 0
                        });
                    }
                }
            }, 500);
            // #endregion
        },
        closeModalOnClickOutside(domEvent) {
            //vars
            let tDialog = this.$refs.dialog;
            //Check
            if (!this.closeOnOutsideClick) {
                return;
            }
            if (utils.isNull(tDialog)) {
                return;
            }
            if (tDialog.contains(domEvent.target)) {
                return;
            }
            //Close
            this.close();
        },
        closeModalOnEscapeKey(event) {
            //Check
            if (!this.closeOnKeyEsc) {
                return;
            }
            if (event.target !== document.activeElement) {
                return;
            }
            if (event.key === 'Escape' || event.keyCode === 27) {
                this.close();
            }
        }
    }
    // #endregion
});
// #endregion
